<template>
  <tr class="attendance">
    <td v-if="this.$route.name != 'meeting-report'" style="cursor: context-menu;">
      <span class="form-control custom"><b>{{ utcToLocal(meeting.start).format('MMM D, YYYY') }}</b></span>
    </td>
    <td>
        <textarea id="first_name" v-model="meeting.first_name" data-test="first_name" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="last_name" v-model="meeting.last_name" data-test="last_name" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td style="padding-top: 15px; font-size: 14px; cursor: context-menu;">
        {{ meeting.email }}
    </td>
    <td>
        <textarea id="job_title" v-model="meeting.job_title" data-test="job_title" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="workplace" v-model="meeting.workplace" data-test="workplace" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="city" v-model="meeting.city" data-test="city" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="country" v-model="meeting.country" data-test="country" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="first_name_curated" v-model="meeting.first_name_curated" data-test="first_name_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="preferred_first_name_curated" v-model="meeting.preferred_first_name_curated" data-test="preferred_first_name_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="middle_name_curated" v-model="meeting.middle_name_curated" data-test="middle_name_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="last_name_curated" v-model="meeting.last_name_curated" data-test="last_name_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="fullname_curated" v-model="meeting.fullname_curated" data-test="fullname_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="preferred_fullname_curated" v-model="meeting.preferred_fullname_curated" data-test="preferred_fullname_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="first_email_curated" v-model="meeting.first_email_curated" data-test="first_email_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="second_email_curated" v-model="meeting.second_email_curated" data-test="second_email_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="first_job_title_curated" v-model="meeting.first_job_title_curated" data-test="first_job_title_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="first_department_curated" v-model="meeting.first_department_curated" data-test="first_department_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="first_hospital_curated" v-model="meeting.first_hospital_curated" data-test="first_hospital_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="second_job_title_curated" v-model="meeting.second_job_title_curated" data-test="second_job_title_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="second_department_curated" v-model="meeting.second_department_curated" data-test="second_department_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="second_hospital_curated" v-model="meeting.second_hospital_curated" data-test="second_hospital_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="workplace_curated" v-model="meeting.workplace_curated" data-test="workplace_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="city_curated" v-model="meeting.city_curated" data-test="city_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="country_curated" v-model="meeting.country_curated" data-test="country_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="profile_link_curated" v-model="meeting.profile_link_curated" data-test="profile_link_curated" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
    <td>
        <textarea id="tags_keywords" v-model="meeting.tags_keywords" data-test="tags_keywords" type="text" class="form-control custom" @keyup.enter="updateAttendee(meeting)"></textarea>
    </td>
  </tr>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    meeting: {
      type: Object,
      default: null,
    },
  },
  methods: {
    utcToLocal: function (dt) {
      return moment.utc(dt).local();
    },
    updateAttendee(attendee){
      this.$http.post('meetings/edit-attendee', attendee);
      /*.then(() => {
        this.$swal.fire({
            icon: 'success',
            title: this.$t('success'),
        }).then(() => {
          this.$emit('reload-meeting-list');
        });
      });*/
    }
  },
};
</script>
<style>
.attendance {
  border-bottom-color: #b9b9d6;
}
.attendance td {
  width: 150px;
  text-align: center;
}
.custom {
  padding: 0.3rem;
  font-size: 14px;
  text-align: center;
  border: none;
  width: inherit;
}
</style>